import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const StrategyVideoTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('secret_strategy_videos', TOUR_DATA.secret_strategy_videos.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Strategy Video Tour
    </button> */}
    </>
  );
};

export default StrategyVideoTour;